'use client';

import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import useModalStore from '@module/stores/useModalStore';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

function InquireAuthChecker() {
  const { pushModal } = useModalStore();
  const { isLogin, isLoginInfoLoading } = useGetLoginInfoQuery();
  const router = useRouter();

  useEffect(() => {
    if (isLoginInfoLoading || isLogin) return;
    const { hash } = window.location;
    if (hash) return;

    pushModal({ type: 'AUTH_MODAL', options: { onClose: () => router.push('/') } });
  }, [isLogin, isLoginInfoLoading, pushModal, router]);

  return null;
}

export default InquireAuthChecker;
